import { useCustomVariation } from "goi_common";
import { useRouter } from "next/router";
import { createContext, ReactNode, useContext } from "react";

/**
 * Hackle 실험 #364 - 후기 개편(메인 B안, 상세 B안) A/B 테스트.
 * 후기 상세(ssr-platform)와 같은 키를 써서 한 사용자가 메인과 상세에서 같은 안을 본다.
 */
export const REVIEW_RENEWAL_EXPERIMENT_KEY = 364;

/** #364 의 모수 중 이 앱이 맡는 곳은 후기 메인뿐이다. */
const REVIEW_MAIN_ROUTE = "/review";

type ReviewRenewalArm = "A" | "B";

const ReviewRenewalExperimentContext = createContext<ReviewRenewalArm>("A");

/** true 면 후기 메인 B안. 헤더와 후기 메인이 같은 값을 읽어 두 표면의 안이 어긋나지 않는다. */
export const useIsReviewRenewalB = () => useContext(ReviewRenewalExperimentContext) === "B";

function AssignedProvider({ children }: { children: ReactNode }) {
  const router = useRouter();
  const variation = useCustomVariation(REVIEW_RENEWAL_EXPERIMENT_KEY);
  // 로컬 next dev 에서는 `?renewal=B` 로 B 를 미리 본다. 배포 환경은 Hackle 배정(dev 는 devtools 강제 배정)을 따른다
  const localPreview = process.env.NODE_ENV === "development" && router.query.renewal === "B";
  // Z(미할당)는 A 와 같이 현행을 그린다
  const arm: ReviewRenewalArm = localPreview || variation === "B" ? "B" : "A";

  return (
    <ReviewRenewalExperimentContext.Provider value={arm}>
      {children}
    </ReviewRenewalExperimentContext.Provider>
  );
}

/**
 * Layout 최상단의 단일 할당 지점. 후기 메인(/review) 밖에서는 훅 자체를 부르지 않아
 * 다른 페이지 방문자에게 #364 노출이 기록되지 않고, 값은 항상 "A" 다.
 */
export function ReviewRenewalExperimentProvider({ children }: { children: ReactNode }) {
  const router = useRouter();

  if (router.pathname !== REVIEW_MAIN_ROUTE) {
    return (
      <ReviewRenewalExperimentContext.Provider value="A">
        {children}
      </ReviewRenewalExperimentContext.Provider>
    );
  }

  return <AssignedProvider>{children}</AssignedProvider>;
}
